import { gql } from '@apollo/client';

export const QUERY_DELIVERY_UNDELIVERED_ATTRIBUTION = gql`
    query QueryDeliveryUndeliveredAttribution($input: DeliveryUndeliveredAttributionQueryInput!) {
        queryDeliveryUndeliveredAttribution(input: $input) {
            hubId
            warehouseId
            sortingCode
            undeliveredCount
            driverSideCount
            driverSideRate
            warehouseSideCount
            warehouseSideRate
            handoverDiffCount
            handoverDiffRate
            returnCount
            returnRate
            otherCount
            otherRate
            outForDeliveryNodeCount
            failedNotReturnedNodeCount
            returnWrongScanCount
            returnWrongUnscanNodeCount
            lostDamagedDriverCount
            notPickedUpCount
            returnNotPutAwayCount
            returnOnPutAwayCount
            returnUnPutAwayCount
            lostDamagedWhsCount
            handoverDiffNodeCount
            returnPkgCount
        }
    }
`;
